// "Add a public figure" (15 October 2026): the window, its two steps.
// A person's gender is never guessed: "their accounts", "their page".
export default {
  titre: 'Add a public figure',
  etapes: { qui: 'Who', comptes: 'Their accounts' },
  qui: {
    aide: 'Someone not yet in the directory: a local official, a party figure, a former minister.',
    libelle: 'Who?',
    placeholder: 'A first and last name',
    resultats: 'Results',
    recherche: 'Searching…',
    aucun: 'No one matches “{q}”.',
    erreur: 'The search did not go through. Try again in a moment.',
    deja: 'Already in the directory',
    voirFiche: 'View their page',
    manque: 'Choose a person from the results.',
    annuaire: 'Members of parliament, MEPs, the Government, party leaders, regional presidents and big-city mayors are already in the directory: just follow them from Public figures.',
  },
  comptes: {
    legende: 'Their accounts, listened to every day',
    aucun: 'No account found: add the ones you know.',
    ajouterUn: 'Add an account',
    adresse: 'Account address',
    placeholder: 'x.com/their_account, instagram.com/…',
    ajouter: 'Add',
    renoncer: 'Do not add an account',
    invalide: 'An account or website address, for example x.com/their_account.',
    ailleurs: 'Orion also listens to what is said everywhere else.',
    reste: 'After this follow, you will have {n} of {max} left.',
    dernier: 'This will be the last of your {max} follows.',
    complets: 'All {max} follows are used: this public figure will join the directory, without a follow.',
  },
  terminer: 'Add and follow',
  erreur: 'Could not add this public figure.',
  sansSuivi: {
    titre: '{nom} joins the directory, without a follow',
    texte: 'Their page is open to everyone, and you can follow them as soon as a follow frees up.',
    introuvable: 'Their page is in Public figures, under “Added”.',
    ouvrir: 'Open their page',
  },
}
